module.exports = __webpack_public_path__ + "static/media/Sherrell_Savage.0eee97bd.webp";